
import { Options, Vue } from 'vue-class-component'
import Research from '@/Research'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import Farm from '@/farm/Farm'
import { ResearchItem } from "@/employee/ResearchItem"

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    item: ResearchItem,
    farm: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    lab() {
      return this.farm.state.lab
    }
  }
})
export default class ResearchThumb extends Vue {
  item!: ResearchItem
  farm!: Farm
}
